import { createRouter, createWebHistory } from 'vue-router'
const routes = [
  //首页
  {
    path: '/',
    component: () => import('@/views/index/index'),
  },//
  //积分榜
  {
    path: '/leagueTable',
    name : 'leagueTable',
    component: () => import('@/views/leagueTable/index'),
    children: [
     
    ]
  },//
  
  //项目
  {
    path: '/project',
    component: () => import('@/views/index/project'),
  },//
  {
    path: '/pdf',
    name: 'pdf',
    component: () => import('@/views/index/pdf'),
  },
  {
    path : '/ranking',
    name : 'ranking',
    component: () => import('@/views/index/ranking'),
    children: [
      //保龄球资格赛
      {
        path: 'bowlingqualification',
        name: 'bowlingqualification',
        component: () => import('../views/showList/qualification.vue'),
      },
      //保龄球排位赛
      {
        path: 'bowlingqualifying',
        name: 'bowlingqualifying',
        component: () => import('../views/showList/qualification.vue'),
      },
      // Repechage
       //保龄球复活赛
       {
        path: 'bowlingRepechage',
        name: 'bowlingRepechage',
        component: () => import('../views/showList/qualification.vue'),
      },
      //保龄球排位赛
      {
        path: 'bowlingfinal8',
        name: 'bowlingfinal8',
        component: () => import('../views/showList/bowlingfinal8.vue'),
      },
      //保龄球八分之一
      {
        path: 'bowlingfinal',
        name: 'bowlingfinal',
        component: () => import('../views/showList/bowlingfinal8.vue'),
      },
      //保龄球八分之一/新
      {
        path: 'bowlingdualmeet',
        name: 'bowlingdualmeet',
        component: () => import('../views/showList/bowlingdualmeet.vue'),
      },
       // 对阵表
       {
        path: '/bowlingmatchsheet',
        name: 'bowlingMatchsheet',
        component: () => import('../views/showList/matchSheet.vue'),
      },
      //保龄球  金牌赛
      {
        path: 'bowlingfinal4',
        name: 'bowlingfinal4',
        component: () => import('../views/showList/bowlingfinal4.vue'),
      },

      // 以下是青少年锦标赛样式
       //保龄球青少年资格赛
       {
        path: 'bowling-qualification',
        name: 'bowling-qualification',
        component: () => import('../views/showList_/qualification.vue'),
      },
      //保龄球青少年资格赛（多人团体）
      {
        path: 'bowling-teamqualification',
        name: 'bowling-teamqualification',
        component: () => import('../views/showList_/teamqualification.vue'),
      },
      //保龄球  金牌赛
      {
        path: 'bowling-final4',
        name: 'bowling-final4',
        component: () => import('../views/showList_/bowling_final4.vue'),
      },
       //保龄球 阶梯挑战赛
       {
        path: 'bowling-final3',
        name: 'bowling-final3',
        component: () => import('../views/showList_/bowling_final3.vue'),
      },
      

     
    ],
  }
]

const routerHistory = createWebHistory()
const router = createRouter({
  history: routerHistory,
  routes: routes
})

router.beforeEach((to, from, next) => {
  // console.log(`我刷新了从:${from.fullPath}到${to.fullPath}`)
 
  next();
})


export default router